'use client';

import { c as _c } from "react/compiler-runtime";
import { SiCloudflare, SiCss, SiDrizzle, SiFigma, SiFirebase, SiGit, SiHtml5, SiJavascript, SiMarkdown, SiMysql, SiNextdotjs, SiNodedotjs, SiPostgresql, SiPrisma, SiPython, SiRadixui, SiReact, SiReactquery, SiTailwindcss, SiTypescript, SiVite, SiVitest } from '@icons-pack/react-simple-icons';
import { ZapIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Marquee } from '@/components/ui/marquee';
export function StacksCard() {
  const $ = _c(9);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ZapIcon className="size-4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("homepage.about-me.stacks");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-2">{t0}<h2 className="text-sm">{t1}</h2></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Marquee gap="20px" className="py-4"><SiHtml5 className="size-10" /><SiCss className="size-10" /><SiJavascript className="size-10" /><SiTypescript className="size-10" /><SiFigma className="size-10" /><SiTailwindcss className="size-10" /><SiNextdotjs className="size-10" /><SiReact className="size-10" /><SiPython className="size-10" /><SiPostgresql className="size-10" /><SiRadixui className="size-10" /></Marquee>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Marquee gap="20px" className="py-4" reverse={true}><SiPrisma className="size-10" /><SiMysql className="size-10" /><SiFirebase className="size-10" /><SiGit className="size-10" /><SiVite className="size-10" /><SiDrizzle className="size-10" /><SiCloudflare className="size-10" /><SiMarkdown className="size-10" /><SiVitest className="size-10" /><SiNodedotjs className="size-10" /><SiReactquery className="size-10" /></Marquee>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <div className="flex h-60 flex-col gap-2 overflow-hidden rounded-2xl p-4 shadow-feature-card lg:p-6">{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}